import { render, staticRenderFns } from "./PageLetbaneError.vue?vue&type=template&id=912a75ba&scoped=true&"
import script from "./PageLetbaneError.vue?vue&type=script&lang=js&"
export * from "./PageLetbaneError.vue?vue&type=script&lang=js&"
import style0 from "./PageLetbaneError.vue?vue&type=style&index=0&id=912a75ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912a75ba",
  null
  
)

export default component.exports